import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Slider } from "@/components/ui/slider";
import { DollarSign } from "lucide-react";

interface Program {
  value: string;
  label: string;
}

interface Country {
  value: string;
  label: string;
}

interface ScholarshipSelectorProps {
  selectedProgram: string;
  selectedCountry: string;
  scholarshipsOnly: boolean;
  maxTuitionFee: number;
  onProgramChange: (value: string) => void;
  onCountryChange: (value: string) => void;
  onScholarshipsOnlyChange: (checked: boolean) => void;
  onMaxTuitionFeeChange: (value: number[]) => void;
  programs: Program[];
  countries: Country[];
}

const ScholarshipSelector = ({
  selectedProgram,
  selectedCountry,
  scholarshipsOnly,
  maxTuitionFee,
  onProgramChange,
  onCountryChange,
  onScholarshipsOnlyChange,
  onMaxTuitionFeeChange,
  programs,
  countries,
}: ScholarshipSelectorProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-12 border rounded-lg p-6 bg-white shadow-sm">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Program
        </label>
        <Select value={selectedProgram} onValueChange={onProgramChange}>
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Select a program" />
          </SelectTrigger>
          <SelectContent>
            {programs.map((program) => (
              <SelectItem key={program.value} value={program.value}>
                {program.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Country
        </label>
        <Select value={selectedCountry} onValueChange={onCountryChange}>
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Select a country" />
          </SelectTrigger>
          <SelectContent>
            {countries.map((country) => (
              <SelectItem key={country.value} value={country.value}>
                {country.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="md:col-span-2">
        <label className="block text-sm font-medium text-gray-700 mb-4 flex items-center gap-2">
          <DollarSign className="h-4 w-4" />
          Maximum Annual Tuition Fee: ${maxTuitionFee.toLocaleString()}
        </label>
        <Slider
          defaultValue={[maxTuitionFee]}
          max={150000}
          step={1000}
          onValueChange={(value) => onMaxTuitionFeeChange(value)}
          className="w-full"
        />
      </div>
      
      <div className="md:col-span-2">
        <label className="flex items-center space-x-2 cursor-pointer">
          <input
            type="checkbox"
            checked={scholarshipsOnly}
            onChange={(e) => onScholarshipsOnlyChange(e.target.checked)}
            className="rounded border-gray-300 text-primary focus:ring-primary"
          />
          <span className="text-sm text-gray-700">Show only universities with scholarships</span>
        </label>
      </div>
    </div>
  );
};

export default ScholarshipSelector;
